import { MiniCartProps } from "@made-people/blueprint-mini-cart";
import { MMMinicartUpsell } from "../../global/MMMiniCartUpsell";
import { MMTrustLogos } from "../../global/MMTrustLogos";
import { getSubtotal } from "../../../utils/format-like-price";
import { MMFreeShippingBanner } from "../../global/MMFreeShippingBanner";

export const MiniCart: MiniCartProps = {
  settings: {
    template: "lyon",
    hasEmptyState: true,
    cartTotals: {
      fieldsEnabled: {
        subtotal: false,
        discount: false,
        tax: false,
        shipping: true,
        grandTotal: true,
      },
      customRows: [
        {
          label: "Checkout_CartTotals_Subtotal",
          value: getSubtotal,
        },
      ],
    },
    aboveCartItemsContent: <MMFreeShippingBanner />,
    miniCartUpsellContent: <MMMinicartUpsell />,
    trustLogosBanner: <MMTrustLogos maxLogos={4} />,
  },
};
